import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";
import {

  PV_LOADING,
  PV_SUCCESS,
  PV_FAILED,
  PV_SAVE_LOADING,
  PV_SAVE_SUCCESS,
  PV_SAVE_FAILED,
  PV_UPDATE_LOADING,
  PV_UPDATE_SUCCESS,
  PV_UPDATE_FAILED

} from "../Constants/pvConstants";

import { handleApiError } from "../Helper/actionHelper";


export const getPv = (update=0) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: PV_LOADING });
    const requestData = {
      token: userLocalData.id,
      is_update: update

    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/pvcheckDetail",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: PV_SUCCESS,
      payload: data,
    });

    handleApiError(data);
  } catch (error) {
    dispatch({
      type: PV_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const savePv = (caseCheckID, checkData, activeTab) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      dispatch({ type: PV_SAVE_LOADING });

      const requestData = {
        token: userLocalData.id,
        case_check_id: caseCheckID,
        check_data: checkData,
      };

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data: result } = await axios.post(FOLDERPATH + 
        "/CandidateApi/savePvcheckDetail",
        requestData,
        {
          headers: headers,
        }
      );

      if (result.status === "success") {
        const { data } = result;
        const payloadData = {
          data: data,
          activeTab: activeTab,
        };
        dispatch({
          type: PV_SAVE_SUCCESS,
          payload: payloadData,
        });

        const msg = "Saved Successfully";

        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      handleApiError(result);
    } catch (error) {
      dispatch({
        type: PV_SAVE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      handleApiError(error);
    }
  };

export const deletePv = () => (dispatch) => {
  dispatch({
    type: PV_SAVE_SUCCESS,
    payload: [],
  });
};





export const updatePv = (caseCheckID, checkData, activeTab) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    dispatch({ type: PV_UPDATE_LOADING });

    const requestData = {
      token: userLocalData.id,
     // case_check_id: caseCheckID,
      is_update: "1",
      check_data: checkData,
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data: result } = await axios.post(FOLDERPATH + 
      "/CandidateApi/updatePvCheckDetails",
      requestData,
      {
        headers: headers,
      }
    );

    if (result.status === "success") {
      const { data } = result;
      const payloadData = {
        data: data,
        activeTab: activeTab,
      };
      dispatch({
        type: PV_UPDATE_SUCCESS,
        payload: payloadData,
      });

      const msg = "Saved Successfully";

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }else{

     // alert(JSON.stringify(result));

      dispatch({
        type: PV_UPDATE_FAILED,
        payload: result.message
      });

      const msg = result.message;

      toast.dismiss();

      toast.error(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    }
    handleApiError(result);
  } catch (error) {
    dispatch({
      type: PV_UPDATE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
    handleApiError(error);
  }
};

export const deleteUpdatePv = () => (dispatch) => {
dispatch({
  type: PV_UPDATE_SUCCESS,
  payload: [],
});
};
